<template>
  <span :class="style">
    {{ label }}
  </span>
</template>

<script>
import Duties from "@/assets/js/duties";

export default {
  props: {
    duty: {
      type: String,
      required: true
    },
    shortDisplayStyle: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    label() {
      if (this.shortDisplayStyle) {
        return this.duty.substring(0, 2);
      }
      return this.duty;
    },

    style() {
      if (this.duty === Duties.attack) return "duty-name--attack";
      if (this.duty === Duties.support) return "duty-name--support";
      return "duty-name--defend";
    }
  }
}
</script>

<style scoped>
  .duty-name--attack {
    color: #06FE65;
  }
  .duty-name--support {
    color: #91CDFE;
  }
  .duty-name--defend {
    color: #FF5353;
  }
</style>
